<template>
  <div>
    <v-dialog :transition="transition" :max-width="width">
      <template v-slot:activator="{ on, attrs }">
        <!-- Provide a default info button slot, but allow overriding.
             This means we need to pass along "on" and "attrs" -->
        <slot name="button" :on="on" :attrs="attrs">
          <v-btn icon :color="color" :small="small" :dense="dense" v-bind="attrs" v-on="on">
            <v-icon :small="small" :dense="dense">{{ icon }}</v-icon>
          </v-btn>
        </slot>
      </template>
      <!-- The modal content goes in the default slot. -->
      <template v-slot:default="dialog">
        <v-card>
          <slot></slot>
          <v-card-actions class="justify-end">
            <v-btn text @click="dialog.value = false">{{ $t('close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
/**
 * Helper component to display a clickable icon that opens into a modal.
 * The text of the modal goes into the default slot.
 */
export default {
  name: 'InfoModal',
  props: {
    width: {
      type: String,
      default: '600'
    },
    icon: {
      type: String,
      default: 'mdi-information'
    },
    color: {
      type: String,
      default: 'primary'
    },
    transition: {
      type: String
    },
    small: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
